import {Matm, Interval} from '../../../classes/Matm';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';
import {DirectionalLight} from '../DirectionalLight';
import {HemisphereLight} from '../HemisphereLight';
import {GridGround} from '../GridGround';
import {Sky} from '../Sky';
import {EnvironmentScenarioBase} from './EnvironmentScenarioBase';

declare let THREE: any;

export class Grid extends EnvironmentScenarioBase {

  private sky: Sky;

  private dirLight: DirectionalLight;
  private hemisphereLight: HemisphereLight;
  private ground: GridGround;
  private grid;

  private gridColor = new ColorInterpolation(
    new THREE.Color(0xffffff),
    new THREE.Color(0x4f4f4f)
  );

  constructor() {
    super();

    const light = new HemisphereLight(
      new ColorInterpolation(
        new THREE.Color(.8, .8, .8),
        new THREE.Color(.6, .6, .6)
      ),
      new ColorInterpolation(
        new THREE.Color(.6, .6, .6),
        new THREE.Color(.1, .1, .1)
      ),
      0.8
    );
    this.add(light);
    this.hemisphereLight = light;

    const dl = new DirectionalLight();
    this.add(dl);
    this.dirLight = dl;

    const sky = new Sky(
      {
        min: 0,
        max: 0.55
      },
      {
        min: 0.2472,
        max: 0.1654
      }
    );
    sky.onSunPositionChange.subscribe(position => dl.position.copy(position));
    this.add(sky);
    this.sky = sky;

    const grid = new THREE.GridHelper(40000, 1600, 0xDBDBDB, 0xDBDBDB);
    grid.name = 'grid';
    this.add(grid);
    this.grid = grid;

    const ground = new GridGround();
    this.add(ground);
    this.ground = ground;

    this.name = 'environment';
  }

  setDayLight(input: Interval) {

    this.sky.interpolate(input);

    const colorInterpolation = Matm.mapRange(input, {min: 0, max: 1});

    this.hemisphereLight.interpolateColor(colorInterpolation);

    this.ground.interpolateColor(colorInterpolation);

    this.grid.material.color.copy(
      this.gridColor.interpolate(colorInterpolation)
    );

    this.dirLight.interpolateIntensity(input);
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/Grid.ts